import { ShieldCheck, Lock, FileCheck2, BadgeCheck } from "lucide-react";

const BADGES = {
  verified: { icon: BadgeCheck, label: "Verified partner" },
  payout: { icon: Lock, label: "Payout-safe booking" },
  policy: { icon: FileCheck2, label: "Clear operating policy" },
  pkr: { icon: ShieldCheck, label: "PKR, no hidden fees" },
};

export function TrustBadge({ kind, className = "" }) {
  const b = BADGES[kind];
  const Icon = b.icon;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border border-primary/15 bg-white/80 px-2.5 py-1 text-xs text-primary ${className}`} data-testid={`trust-badge-${kind}`}>
      <Icon className="h-3.5 w-3.5" strokeWidth={1.6} /> {b.label}
    </span>
  );
}

export function ScarcityTag({ spotsLeft, capacity }) {
  if (spotsLeft === 0) return <span className="eyebrow rounded-full bg-foreground px-2.5 py-1 text-white" data-testid="scarcity-sold-out">Sold out</span>;
  if (spotsLeft <= Math.max(3, Math.ceil(capacity * 0.3)))
    return <span className="eyebrow rounded-full bg-secondary px-2.5 py-1 text-white" data-testid="scarcity-tag">{spotsLeft} spots left</span>;
  return null;
}
